<form class="ui form" #form="ngForm" autocomplete="off">
    <h2>{{ 'forms.setup-complete.header' | translate }}</h2>
    <div>
        <img src="/assets/illustrations/desktop.png" />
    </div>
    <h3>{{ 'forms.setup-complete.message' | translate }}</h3>
</form>
